import React from 'react';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import EvolutionTooltip from './EvolutionTooltip';

type Props = {
    value: number;
    lastYearValue?: number;
    lastYear: number;
    formattedLastYearValue?: string;
};

const NeutralEqualityIcon = (
    <HorizontalRuleIcon
        sx={(theme) => ({ color: theme.palette.orange })}
        fontSize="small"
    />
);

const DecreasingEvolutionIcon = (
    <TrendingDownIcon
        sx={(theme) => ({ color: theme.palette.green })}
        fontSize="small"
    />
);

const IncreasingEvolutionIcon = (
    <TrendingUpIcon
        sx={(theme) => ({ color: theme.palette.red })}
        fontSize="small"
    />
);

const EvolutionIcon = ({
    value,
    lastYearValue,
    lastYear,
    formattedLastYearValue,
}: Props): React.ReactElement => {
    if (lastYearValue === undefined || value === lastYearValue) {
        return NeutralEqualityIcon;
    }
    const evolutionValue =
        lastYearValue && lastYearValue > 0
            ? ((value - lastYearValue) / lastYearValue) * 100
            : undefined;
    return (
        <EvolutionTooltip
            evolutionValue={evolutionValue}
            lastYear={lastYear}
            formattedLastYearValue={formattedLastYearValue}
        >
            {lastYearValue > value
                ? DecreasingEvolutionIcon
                : IncreasingEvolutionIcon}
        </EvolutionTooltip>
    );
};

export default React.memo(EvolutionIcon);
